import { SearchEvent } from '@df/search/search-event';

export class SearchClearEvent extends SearchEvent {}
